import props from './props'
import computed from './computed'
export default {
  props,
  computed
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/specializations/resources/index.js